import axiosInstance from "./axiosInstance";

// export const getImages = async () => {
//   const res = await axiosInstance.get("/images");
//   return res.data.images;
// };

// // BEFORE SEPARATING THE ADMIN SECTIONS
// export const getImages = async () => {
//   try {
//     console.log("Making API request to /images...");
//     const res = await axiosInstance.get("/images");  // ⬅️ Remove category filtering
//     console.log("API response in getImages:", res.data); // Log API response
//     return res.data.images;
//   } catch (error) {
//     console.error("Error fetching images from API:", error);
//     throw error;
//   }
// };

// // export const getImages = async (category) => {
// //   try {
// //     console.log("Making API request to /images...");
// //     // const res = await axiosInstance.get("/images");
// //     const res = await axiosInstance.get(`/images${category ? `?category=${category}` : ""}`);
// //     console.log("API response in getImages:", res.data); // Log API response
// //     return res.data.images;
// //   } catch (error) {
// //     console.error("Error fetching images from API:", error);
// //     throw error;
// //   }
// // };

// // BEFORE SEPARATING THE ADMIN SECTIONS
// export const getImageById = async (id) => {
//   const res = await axiosInstance.get(`/images/${id}`);
//   return res.data.image;
// };

// // BEFORE SEPARATING THE ADMIN SECTIONS
// export const uploadImage = async (formData) => {
//   const res = await axiosInstance.post("/images/upload", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return res.data.image;
// };

// // BEFORE SEPARATING THE ADMIN SECTIONS
// Create an external image (e.g., hosted URL)
// export const createExternalImage = async (imageData) => {
//   try {
//     const res = await axiosInstance.post("/images/external", imageData);
//     console.log("✅ API Response for createExternalImage:", res.data); // Log API response
//     return res.data.image;
//   } catch (error) {
//     console.error("❌ Error creating external image:", error.response?.data || error.message);
//     throw error;
//   }
// };

// AFTER SEPARATING THE ADMIN SECTIONS
export const createExternalImage = async (imageData) => {
  if (!imageData.category) throw new Error("Category is required for adding external images.");

  try {
    console.log("📤 Sending external image data:", imageData);
    
    const res = await axiosInstance.post("/images/external", imageData); // ✅ Ensure category is sent
    console.log("✅ API Response for createExternalImage:", res.data);
    
    return res.data.image;
  } catch (error) {
    console.error("❌ Error creating external image:", error.response?.data || error.message);
    throw error;
  }
};



// // BEFORE SEPARATING THE ADMIN SECTIONS
// export const updateImage = async (id, formData) => {
//   const res = await axiosInstance.put(`/images/${id}`, formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return res.data.image;
// };

// // BEFORE SEPARATING THE ADMIN SECTIONS
// export const deleteImage = async (id) => {
//   const res = await axiosInstance.delete(`/images/${id}`);
//   return res.data;
// };

// export const getImages = async (category = "News & Media") => {
  export const getImages = async (category) => {

    if (!category) throw new Error("Category is required for fetching images.");

  try {
    console.log(`🔵 Fetching images for category: ${category}`);
    
    const res = await axiosInstance.get(`/images?category=${encodeURIComponent(category)}`);
    
    console.log("🟢 API response in getImages:", res.data);
    return res.data.images;
  } catch (error) {
    console.error("❌ Error fetching images:", error.response?.data || error.message);
    throw error;
  }
};


// export const uploadImage = async (formData, category) => {
//   if (!category) throw new Error("Category is required for uploading images.");

//   formData.append("category", category); // ✅ Add category to form data
//   const res = await axiosInstance.post("/images/upload", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });

//   return res.data.image;
// };

// export const uploadImage = async (formData, category) => {

//   if (!category) throw new Error("Category is required for uploading images");
//   // if (!formData.has("category")) {
//   //   throw new Error("Category is required for uploading images.");
//   // }

//   formData.append("category", category);

//   const res = await axiosInstance.post("/images/upload", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });

//   return res.data.image;
// };

export const uploadImage = async (formData, category) => {
  if (!category) throw new Error("Category is required for uploading images.");

  if (!formData.has("category")) {
    formData.append("category", category); // ✅ Ensure category is properly added
  }

  // ✅ Debugging FormData before sending
//   console.log("📤 Final FormData being sent:");
//   for (let [key, value] of formData.entries()) {
//     console.log(`${key}:`, value);
//   }

//   const res = await axiosInstance.post("/images/upload", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });

//   return res.data.image;
// };

// ✅ Debugging FormData before sending
console.log("📤 Final FormData being sent:");
for (let [key, value] of formData.entries()) {
  console.log(`${key}:`, value);
}

try {
  const res = await axiosInstance.post("/images/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  console.log("✅ Upload successful, response data:", res.data);
  return res.data.image;
} catch (error) {
  console.error("❌ Error uploading image:", error.response?.data || error.message);
  throw error;
}
};



export const updateImage = async (id, formData, category) => {
  if (!category) throw new Error("Category is required for updating images.");

  formData.append("category", category);
  const res = await axiosInstance.put(`/images/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data.image;
};

// export const deleteImage = async (id, category) => {
//   if (!category) throw new Error("Category is required for deleting images.");

//   const res = await axiosInstance.delete(`/images/${id}?category=${category}`);
//   return res.data;
// };

export const deleteImage = async (id) => {
  if (!id) throw new Error("Image ID is required for deleting images.");

  const res = await axiosInstance.delete(`/images/${id}`);
  return res.data;
};


